<section class="grid w-full h-screen grid-cols-1 bg-primary-white-01 md:grid-cols-2">
    <div class="grid place-items-center">
        <div class="flex flex-col w-full px-5 max-w-100">
            <p class="title-6 text-primary-black-01">Bienvenido, {{ user?.NOMBRE }}</p>
            <p class="mt-2 paragraph-4 text-primary-gray-01">Por seguridad, cambia tu contraseña por primera vez.</p>

            <div class="relative">
                <mat-icon class="w-[88px] h-[32px] min-w-[88px] min-h-[32px] -top-60 absolute" svgIcon="icons:logo-claro-icon"></mat-icon>
            </div>

            <!-- Alert -->
            <fuse-alert
                class="mt-8 mb-4"
                *ngIf="showAlert"
                [appearance]="'outline'"
                [showIcon]="'false'"
                [type]="alert.type"
                [@shake]="alert.type === 'error'">
                {{ alert.message }}
            </fuse-alert>

            <form [formGroup]="pass" #signInNgForm="ngForm" class="mt-3">
                <mat-form-field hideRequiredMarker class="w-full">
                    <mat-label>Nueva contraseña</mat-label>
                    <input
                        formControlName="CLAVE_NUEVA"
                        name="password"
                        type="password"
                        matInput
                        [type]="hidePass ? 'password' : 'text'"
                        placeholder="Contraseña" />
                    <button mat-icon-button matSuffix (click)="hidePass = !hidePass" [attr.aria-label]="'hidePass'" [attr.aria-pressed]="hidePass">
                        <mat-icon *ngIf="hidePass" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-solid"></mat-icon>
                        <mat-icon *ngIf="!hidePass" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-off-solid"></mat-icon>
                    </button>
                    <mat-error>
                        <p>Contraseña es requerida y debe contener al menos: 8 caracteres, 1 mayúscula o minúscula, 1 número, 1 caracter especial.</p>
                    </mat-error>
                </mat-form-field>

                <mat-form-field hideRequiredMarker class="w-full">
                    <mat-label>Repetir nueva contraseña</mat-label>
                    <input
                        formControlName="CLAVE_REPEAT"
                        name="confirmPassword"
                        matInput
                        [type]="hidePassRepeat ? 'password' : 'text'"
                        placeholder="Contraseña" />

                    <button
                        mat-icon-button
                        matSuffix
                        (click)="hidePassRepeat = !hidePassRepeat"
                        [attr.aria-label]="'hidePassRepeat'"
                        [attr.aria-pressed]="hidePassRepeat">
                        <mat-icon *ngIf="hidePassRepeat" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-solid"></mat-icon>
                        <mat-icon *ngIf="!hidePassRepeat" class="w-[16px] h-[11px] text-primary" svgIcon="icons:eye-off-solid"></mat-icon>
                    </button>

                    <mat-error>
                        <p>Las contraseñas no coinciden.</p>
                    </mat-error>
                </mat-form-field>

                <!-- <mat-form-field class="w-full">
                    <mat-label>Contraseña</mat-label>

                    <input
                        id="password"
                        matInput
                        formControlName="password"
                        #passwordField
                        [type]="hide ? 'password' : 'text'"
                        placeholder="Contraseña"
                    />

                    <button
                        mat-icon-button
                        matSuffix
                        (click)="hide = !hide"
                        [attr.aria-label]="'Hide password'"
                        [attr.aria-pressed]="hide"
                    >
                        <mat-icon
                            *ngIf="hide"
                            class="w-[16px] h-[11px] text-primary"
                            svgIcon="icons:eye-solid"
                        ></mat-icon>
                        <mat-icon
                            *ngIf="!hide"
                            class="w-[16px] h-[11px] text-current"
                            svgIcon="icons:eye-off-solid"
                        ></mat-icon>
                    </button>
                </mat-form-field> -->

                <button
                    mat-flat-button
                    class="flex items-center justify-center w-full h-10 btn-md"
                    (click)="changePassword()"
                    [color]="'primary'"
                    [disabled]="!pass.valid"
                    [ngClass]="{
                        'bg-primary text-gray-500': !pass.valid,
                        'bg-primary text-white': pass.valid
                    }">
                    Cambiar contraseña
                </button>
            </form>
        </div>
    </div>
    <div
        class="relative hidden bg-center bg-no-repeat bg-cover md:grid place-items-center"
        style="background-image: url('../../../../assets/imgs/login.webp')"></div>
</section>
